export default __webpack_public_path__ + "static/media/icon.07abc655.svg";